import { Injectable } from '@angular/core';
import { DealerPartSearchObj } from '../business-entities/dealer-part-search-object-view-model';
import { DealerPartsListviewModel } from '../business-entities/dealer-parts-list-view-model';
import { GenericResponse } from '../business-entities/generic-response';
import { PartsListViewModel } from '../business-entities/parts-list-view-model';
import { SelectListItemViewModel } from '../business-entities/select-list-item-view-model';
import { DealerPartsDataService } from '../data-services/dealer-parts-data.service';

@Injectable({
  providedIn: 'root'
})
export class DealerPartsService {
  dealerPartsSearchList: DealerPartsListviewModel;
  partsList: PartsListViewModel[];
  dealerId: string = '';
  dealerPartId: number;
  dealerList: Array<SelectListItemViewModel>;
  constructor(private service: DealerPartsDataService) { }
  dealerPartsList: PartsListViewModel[];

  async getDealerPartsListById(dealerId: string,LanguageCode:string): Promise<PartsListViewModel[]> {

    await this.service
      .getDealerPartsListById(dealerId,LanguageCode)
      .then(
        (res: GenericResponse<PartsListViewModel[]>) => {
          this.dealerPartsList = res.responseObject;
        }
      );
    return this.dealerPartsList;
  }
  addDealerParts(model: any): Promise<any> {
    return this.service.addDealerParts(model);
  }
  updateDealerParts(model: any): Promise<any> {
    return this.service.updateDealerParts(model);
  }
  async getDealerPartById(viewModel:any) {
    return this.service.getDealerPartById(viewModel);
  }
  async getDealerAndPartSearch(searchObj: DealerPartSearchObj) {
    await this.service
      .getDealerAndPartSearch(searchObj)
      .then(
        (res: GenericResponse<DealerPartsListviewModel>) => {

          this.dealerPartsSearchList = res.responseObject;
        }
      );

    return this.dealerPartsSearchList;
  }




}
